<section class="get-project s4">
    <div class="container">
      <div class="row">
        <div class="col-lg-6">
          <div class="featured-post animate-element wow delay5 fadeZooming" data-wow-delay="0.5s">
            <img style="border-radius: 20px;" src="assets/images/section/nae44.jfif" alt="images">
          </div>
        </div>
        <div class="col-lg-6">
          <div class="content-inner animate-element wow delay5 fadeInUp" data-wow-delay="0.5s">
            <h2 class="title mg-b14 color-d11">Hey, I'm Naomi Céspedes.</h2>
            <div class="site-list has-border">
              <a href="https://www.linkedin.com/in/naeliza/" class="bg-s1"><i class="fa fa-linkedin"
                  aria-hidden="true"></i></a>
              <a href="mailto:lizcespedes0326@gmail.com" class="bg-s3"><i class="fa fa-google"
                  aria-hidden="true"></i></a>
              <a href="https://github.com/Naeliza" class="bg-s4"><i class="fa fa-github" aria-hidden="true"></i></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>